<script lang="ts">
    import {createMasonryGridContext} from 'shared/layouts';
    import type {CssSize} from 'shared/ui-widgets/types';
    import {onMount, afterUpdate, tick} from 'svelte';
    import {debounce} from 'lodash-es';

    export let gap: CssSize = '30px';
    export let gridWidth: CssSize | null = null;
    export let gridHeight: CssSize | null = null;
    export let debounceInterval = 300;
    export let gridTemplateColumns = 'repeat(auto-fill, minmax(170px, 1fr))';
    export let additionalClasses = '';

    let gridElement: HTMLDivElement | null = null;
    let computedRowGap = 0;
    let computedColumnWidth = 0;

    function adjustItemSize(item: HTMLElement) {
        const itemHeight = item.getBoundingClientRect().height;
        const rowSpanCount = Math.ceil((itemHeight + computedRowGap) / computedRowGap);
        item.style.gridRowEnd = `span ${rowSpanCount}`;
    }

    export function updateGrid() {
        if (!gridElement) {
            return;
        }

        computedColumnWidth = parseFloat(getComputedStyle(gridElement).gridTemplateColumns);
        computedRowGap = parseInt(getComputedStyle(gridElement).rowGap, 10);
        const gridItems = Array.from(gridElement.children);
        gridItems.forEach(adjustItemSize);
    }

    afterUpdate(() => {
        updateGrid();
    });

    onMount(() => {
        updateGrid();
    });

    const handleResize = () => {
        debounce(() => tick().then(() => updateGrid()), debounceInterval);
    }

    createMasonryGridContext(updateGrid, gap);
</script>

<svelte:window on:resize={handleResize}/>

<div class="masonry-grid {additionalClasses}"
     bind:this={gridElement}
     style:--column-gap={gap}
     style:--width={gridWidth}
     style:--height={gridHeight}
     style:--columns={gridTemplateColumns}>

    <slot {updateGrid} {computedColumnWidth}/>
</div>

<style lang="less">
    .masonry-grid {
        display: grid;
        column-gap: var(--column-gap);
        row-gap: 1px;
        grid-template-columns: var(--columns);
        grid-auto-rows: 0;
        width: var(--width);
        height: var(--height);
    }
</style>